export default "__VITE_ASSET__CoJvNpLz__"